export const getBinario = (orden, extension) => {
  const isPng = "data:image/png;base64,";
  const isJpg = "data:image/jpg;base64,";
  const isJpeg = "data:image/jpeg;base64,";
  let binario = "";

  switch (extension) {
    case "png":
      binario = orden.replace(isPng, "");
      break;
    case "jpg":
      binario = orden.replace(isJpg, "");
      break;
    default:
      binario = orden.replace(isJpeg, "");
  }
  return binario;
};
